import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchReservation } from "../../redux/action";

import CommonSearchBox from "../../component/SearchBox/CommomSearchBox";
import ReservationCard from "./ReservationCard";

import "./ReservationMobileList.css";
import EmptyScreen from "../../component/common/EmptyScreen";

function ReservationMobileList({ onEdit, onStatus, onView }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const { reservations = {} } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(fetchReservation());
  }, [dispatch]);

  const handleEdit = (reservation) => {
    onEdit();
    dispatch({
      type: "EDIT_RESERVATION",
      payload: reservation
    });
  };

  const filteredReservations = Object.values(reservations).filter((reservation) => {
    const reservationDate = reservation.reservationDate
      ? reservation.reservationDate.split("T")[0].toLowerCase()
      : "";

    return (
      reservation.customerName?.toLowerCase().includes(search.toLowerCase()) ||
      reservation.mobileNumber?.toLowerCase().includes(search.toLowerCase()) ||
      reservation.status?.toLowerCase().includes(search.toLowerCase()) ||
      reservationDate.includes(search.toLowerCase()) ||
      reservation.numberOfGuests?.toString().includes(search) ||
      reservation.reservationTime?.toLowerCase().includes(search.toLowerCase()) ||
      reservation.restaurantTable?.tableName?.toString().includes(search)
    );
  });

  return (
    <div className="reservation-container">

      {filteredReservations.length === 0 ? (
        <EmptyScreen message="No orders found for the selected date range." />
      ) : (
        <>
          <CommonSearchBox
            placeholder="Search customer, mobile, table, status..."
            search={search}
            setSearch={setSearch}
          />
          <ul className="reservation-list">
            {filteredReservations.map((res) => (
              <ReservationCard
                key={res.reservationId}
                res={res}
                onEdit={handleEdit}
                onStatus={onStatus}
                onView={onView}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default ReservationMobileList;
